import { render, staticRenderFns } from "./GramCv.vue?vue&type=template&id=43a3ea3a"
import script from "./GramCv.vue?vue&type=script&lang=ts"
export * from "./GramCv.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports